import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  en: {
    navbar: {
      home: "Home",
      register: "Register",
      admins: "Users",
      customers: "Customers",
      prospects: "Prospects",
      profile: "Profile",
      devices: "Devices",
      language: "ภาษาไทย",
      dropdown: {
        welcome: "Welcome, ",
        setting: "Setting",
        re_login: "Re-Login",
        logout: "Logout",
        version: "Version "
      }
    },
    home: {
      dashboard: {
        title: "Today Customer Summary",
        updated: "Last Updated",
        prospect_title: "Prospect Customers",
        total_prospect: "Total New Prospect",
        in_area: "In Area",
        out_area: "Out Area",
        call_title: "Call Response",
        total_call: "Total Call Out",
        call_accept: "Accepted",
        call_reject: "Rejected",
        new_customer_title: "New Customers",
        from_prospect: "Prospects",
        from_sale: "Other Sales"
      },
      title: "What do you want to do today?",
      register: "Customer Registeration",
      admins: "Manage Admin Users",
      customers: "Customers' Info.",
      prospect: "Prospect Customers",
      profile: "My Profile",
      devices: "Manage Devices"
    },
    register: {
      service_area: "Check Service",
      number_register: "Register Number",
      search: {
        placeholder: "Enter a location address",
        search_btn: "Search",
        next_btn: "Next"
      },
      form: {
        contact_number: {
          info: "Please enter an contact number to verifiy it via OTP",
          placeholder: "Input your contact number",
          send_otp_btn: "Request OTP"
        },
        otp: {
          title: "Confirm Your OTP",
          number_info: "An OTP was sent to ",
          refcode_info: "Please filled it. Ref.",
          placeholder: "4-digits OTP",
          close_btn: "Close",
          confirm_btn: "Confirm"
        },
        imei_number: {
          title: "Verified IMIE Number",
          info: "Please enter dtac@home number to verify an IMEI",
          placeholder: {
            dah: "Dtac@home number",
            imei: "IMEI No."
          },
          register_btn: "Register"
        },
        success_register: {
          title: "Register Success",
          content: {
            msisdn: "Dtac@Home Number",
            contact_number: "Contact Number",
            imie: "IMEI Number",
            date_created: "Create at"
          },
          to_register_btn: "Back to Register"
        },
        back_btn: "Back"
      }
    },
    users: {
      title: "Dtac@home Users List",
      desc_search_user: "Please enter an dtac user LAN",
      btn_search_user: "Search",
      btn_create_user: "Create New User",
      form_create_user: {
        title: "Create New Admin User",
        channel: "Channel",
        channel_placeholder: "Please enter user channel",
        info: "Please input user LAN and select role for created users.",
        info_username: "Please enter an dtac user LAN.",
        info_roles: "Please select user access options."
      },
      table_header: {
        email: "Email",
        name: "Fullname",
        msisdn: "Phone No.",
        username: "Username",
        last_login: "Last Login",
        channel: "Channel",
        status: "Status",
        action: "Action"
      },
      account_status: {
        active: "Active",
        pending: "Pending",
        inactive: "Inactive"
      },
      table_details: {
        report: "Report",
        map_area: "Map Area",
        user_manage: "Manage User",
        device_list: "Get Devices",
        device_update: "Update Devices",
        customer_register: "Register Customer",
        customer_list: "Get Customer List",
        customer_update: "Update Customers",
        customer_distance: "Adjust Lock Distance",
        customer_propect: "Get Prospect Customers",
        customer_prospect_update: "Update Prospect Customers",
        bypass_otp: "Bypass OTP",
        btn_save: "Save"
      }
    },
    customer: {
      title: "Search Customer",
      search: {
        title: "Please input msisdn, imei ,or serial no.",
        button: "search"
      },
      options: {
        yesterday: "Yesterday",
        threedays: "3 Days",
        week: "7 Days",
        month: "30 Days",
        all: "All Time"
      },
      detail: {
        customer_number: "Customer Number",
        package_code: "Package Code",
        msisdn: "msisdn",
        esn: "ESN",
        imei: "IMEI",
        contact_number: "Contact Number",
        location: "Registered Location (Lat,Lng)",
        distance: "Lock Distance (m.)",
        created_date: "Created Date",
        register_date: "Register Date",
        pcrf_status: "PCRF Status",
        customer_status: "Customer Status",
        sms_lang: "SMS Language",
        telp_type: "Tel Type",
        site_prefix: "Province",
        pcrf: {
          count: "Out of Area Counter",
          last_active: "updated"
        },
        back: "Back",
        unregister: "Unregister"
      },
      tabs: {
        title: {
          home_location: "Customer Location",
          retry_queue: "Retry Queue",
          customer_history: "Customer History",
          pcrf_history: "PCRF History"
        },
        table: {
          created: "วันที่",
          action: "สถานะ",
          retry_queue: {
            not_found: "Retry queue not found...",
            transaction_id: "Transaction ID",
            retry_count: "Retry Count",
            next_retry: "Retry ครั้งต่อไป",
            type: "Type"
          },
          cust_history: {
            not_found: "Customer history not found...",
            event: "Edited Field",
            old: "Old Data",
            new: "New Data",
            create_by: "Edited By"
          },
          pcrf_history: {
            not_found: "PCRF history not found..."
          }
        }
      },
      unregister_popup: {
        title: "Unregister",
        description: "Please confirm unregister action for msisdn  ",
        confirm: "Confirm",
        cancel: "Not Now"
      }
    },
    prospects: {
      title: "Prospects Customer List",
      table_header: {
        created: "Created Date",
        name: "Customer Name",
        msisdn: "Phone No.",
        global_id: "Global ID",
        email: "Email",
        address: "Address",
        province: "Province",
        coordinate: "Location ( Lat, Lng )",
        area_status: "Status",
        action: "Action",
        tooltip: "Employee Deals"
      },
      detail_title: {
        change_event: "Changed Event",
        last_updated: "Last Updated",
        updated_date: "updated at",
        by: "by"
      },
      call_status_title: {
        new: "New",
        called: "Pending",
        accepted: "Accepted"
      },
      area_status_title: {
        in_area: "Service Available",
        out_area: "Service Unavailable"
      },
      dialog: {
        remove: {
          title: "Remove Prospect Customer",
          message: "Are you sure to permanently remove",
          confirmText: "Remove"
        },
        cancel: {
          title: "Confirm Cancel Prospect's Offering ",
          message:
            "Are you sure to cancel prospect's offering which will permanently remove the profile",
          confirmText: "Confirm"
        },
        call: {
          title: "Prospect Customer Contact Status",
          message: "Please select call feedback from K.",
          accepted: "Accept",
          rejected: "Reject"
        },
        register: {
          title: "Register Prospect Customer",
          message: "Are you sure to register ",
          confirmText: "Register"
        },
        cancelText: "Cancel"
      }
    },
    myprofile: {
      email: "Email",
      status: {
        active: "Active",
        pending: "pending"
      },
      permission: {
        title: "Permissions",
        map_area: "Sales Area Planning",
        customer_register: "Customer Registeration",
        customer_list: "View Customers' Info.",
        customer_update: "Manage Customers' Info.",
        report: "View Report",
        user_manage: "Manage Admin Users"
      },
      created: {
        title: "Created at",
        by: "by"
      }
    },
    devices: {
      title: "Device Management",
      search: {
        placeholder: "Please input msisdn, imei ,or serial no.",
        button: "Filter"
      },
      btn_create_device: "Add New Device",
      table_header: {
        created: "Create Date",
        msisdn: "msisdn",
        imei: "IMEI",
        esn: "ESN"
      },
      form: {
        title: "Add New Device",
        info:
          "Please input textare with CSV format ( msisdn, IMEI, ESN, tel_type respectively )",
        placeholder:
          "msisdn-001,IMEI-001,ESN-001,T\nmsisdn-002,IMEI-002,ESN-002,T\nmsisdn-003,IMEI-003,ESN-003,P"
      }
    },
    site: {
      coverage: "Coverage (m.)",
      distance: "Distance (m.)",
      utilize: "Utilzation (%)",
      cell: {
        location: "Cell's Location (Lat, Lng)"
      }
    },
    form: {
      imei: {
        title: "Update New IMEI",
        current_imei: "Current IMEI",
        description: "Please input a new IMEI in the field below",
        placeholder: "Enter new IMEI"
      },
      distance: {
        title: "Update New Lock Distance",
        current_distance: "Current Lock Radius",
        unit: "m.",
        description: "Please input a new lock distance in the field below",
        placeholder: "Enter new lock distance"
      },
      contact: {
        title: "Update Contact Number ",
        current_contact: "Current Contact Number",
        description:
          "To complete th process, Please enter new contact number and verified it with sent OTP.",
        placeholder: "Enter new contact number"
      },
      location: {
        title: "Update Registered Location"
      }
    },
    maps: {
      service_available: "Service Available",
      service_unavailable: "Service Unavailable",
      site_available: "Site Available",
      site_unavailable: "Site Unavailable"
    },
    alert: {
      token_not_found: "Contact Token not found",
      new_contact: "Please input Your New Contact Number",
      update_contact: "Updated Contact Number Successfully",
      user_lan: "Please input user LAN",
      new_user_lan: "Add New User Successfully",
      wrong_format_input:
        "Wrong Input Format, Please input Address or (Latitude, Longitude).",
      valid_contact: "This contact number is valid"
    }
  },
  th: {
    navbar: {
      home: "หน้าแรก",
      register: "ลงทะเบียน",
      admins: "ผู้ใช้งานระบบ",
      customers: "ข้อมูลลูกค้า",
      prospects: "ลูกค้าที่สนใจ",
      profile: "ข้อมูลส่วนตัว",
      devices: "อุปกรณ์",
      language: "English",
      dropdown: {
        welcome: "ยินดีต้อนรับ",
        setting: "การตั้งค่า",
        re_login: "รีเซ็ท Session",
        logout: "ออกจากระบบ",
        version: "เวอร์ชั่น "
      }
    },
    home: {
      dashboard: {
        title: "สรุปข้อมูลลูกค้าวันนี้",
        updated: "ข้อมูลเมื่อ",
        prospect_title: "ลูกค้าที่สนใจ",
        total_prospect: "ลูกค้าที่สนใจทั้งหมด",
        in_area: "ในพื้นที่",
        out_area: "นอกพื้นที่",
        call_title: "รายการโทรออก",
        total_call: "โทรออกทั้งหมด",
        call_accept: "ตกลงซื้อ",
        call_reject: "ปฏิเสธ",
        new_customer_title: "ลูกค้าใหม่",
        from_prospect: "ลูกค้าที่สนใจ",
        from_sale: "ช่องทางอื่นๆ"
      },
      title: "วันนี้ทำอะไรดี ?",
      register: "ลงทะเบียนลูกค้า",
      admins: "จัดการผู้ใช้งานระบบ",
      customers: "ดูข้อมูลลูกค้าผู้ใช้งาน",
      prospect: "ดูข้อมูลลูกค้าที่สนใจ",
      profile: "ข้อมูลส่วนตัวของฉัน",
      devices: "จัดการอุปกรณ์"
    },
    register: {
      service_area: "ตรวจสอบพื้นที่ให้บริการ",
      number_register: "ลงทะเบียนเบอร์",
      search: {
        placeholder: "กรุณากรอกข้อมูลที่อยู่",
        search_btn: "ค้นหา",
        next_btn: "ต่อไป"
      },
      form: {
        contact_number: {
          info:
            "กรุณากรอกข้อมูลเบอร์ติดต่อ เพื่อที่ระบบจะทำการส่งรหัส OTP ไปยังหมายเลขที่ท่านกรอกไว้",
          placeholder: "กรุณากรอกเบอร์ติดต่อ",
          send_otp_btn: "ส่งคำขอ OTP"
        },
        otp: {
          title: "กรุณายืนยัน OTP",
          number_info: "OTP ได้ถูกส่งไปยังหมายเลข ",
          refcode_info: "กรุณากรอกในช่องด้านล่าง Ref.",
          placeholder: "หมายเลข OTP 4 หลัก",
          close_btn: "ปิด",
          confirm_btn: "ยืนยัน"
        },
        imei_number: {
          title: "ตรวจสอบหมายเลขเครื่อง",
          info: "กรุณากรอกหมายเลขดีแทค@โฮม เพื่อทำการตรวจสอบเลขเครื่อง",
          placeholder: {
            dah: "หมายเลขดีแทค@โฮม",
            imei: "เลขเครื่อง (IMEI)"
          },
          register_btn: "ลงทะเบียน"
        },
        success_register: {
          title: "ลงทะเบียนสำเร็จ",
          content: {
            msisdn: "หมายเลขดีแทค@โฮม",
            contact_number: "หมายเลขติดต่อ",
            imie: "หมายเลขเครื่อง (IMEI)",
            date_created: "วันที่สร้าง"
          },
          to_register_btn: "กลับไปยังหน้าลงทะเบียน"
        },
        back_btn: "กลับ"
      }
    },
    users: {
      title: "รายชื่อผู้ใช้งานระบบ Dtac@home",
      desc_search_user: "กรุณากรอก User LAN ที่ต้องการค้นหา",
      btn_search_user: "ค้นหา",
      btn_create_user: "เพิ่มผู้ใช้งานระบบ",
      form_create_user: {
        title: "เพิ่มผู้ใช้งานระบบใหม่",
        channel_placeholder: "กรุณาใส่ชาแนลของผู้ใช้ระบบ",
        channel: "ช่องทางการเพิ่มผู้ดูแลระบบ",
        info: "กรอก User LAN ในช่องด้านล่าง และเลือกประเภทการเข้าถึงให้ครบถ้วน",
        info_username: "กรุณากรอก User LAN ของท่าน",
        info_roles: "กรุณาเลือกการเข้าถึงของผู้ใช้คนนี้"
      },
      table_header: {
        email: "อีเมล์",
        name: "ชื่อ-นามสกุล",
        msisdn: "หมายเลขโทรศัพท์",
        username: "ชื่อบัญชี",
        last_login: "เข้าใช้งานล่าสุด",
        channel: "ชาแนล",
        status: "สถานะ",
        action: "จัดการ"
      },
      account_status: {
        active: "ใช้งานได้ปกติ",
        pending: "ยังไม่เข้าสู่ระบบ",
        inactive: "ไม่สามารถใช้งานได้"
      },
      table_details: {
        report: "รายงาน(ดูข้อมูล)",
        map_area: "พื้นที่การขาย(ดูข้อมูล)",
        user_manage: "ผู้ใข้งานในระบบ(แก้ไข)",
        device_list: "อุปกรณ์(ดูข้อมูล)",
        device_update: "อุปกรณ์(แก้ไขข้อมูล)",
        customer_register: "ลูกค้า(ลงทะเบียน)",
        customer_list: "ลูกค้า(ดูข้อมูล)",
        customer_update: "ลูกค้า(แก้ไขข้อมูล)",
        customer_distance: "ลูกค้า(แก้ไขระยะล๊อค)",
        customer_propect: "ลูกค้าที่สนใจ(ดูข้อมูล)",
        customer_prospect_update: "ลูกค้าที่สนใจ(แก้ไขข้อมูล)",
        bypass_otp: "Bypass OTP",
        btn_save: "บันทึก"
      }
    },
    customer: {
      title: "ค้นหาข้อมูลลูกค้า",
      search: {
        title: "กรุณากรอกหมายเลขโทรศัพท์, เลขimei หรือ หมายเลขเครื่อง",
        button: "ค้นหา"
      },
      options: {
        yesterday: "เมื่อวาน",
        threedays: "3 วัน",
        week: "7 วัน",
        month: "30 วัน",
        all: "ตั้งแต่วันแรก"
      },
      detail: {
        customer_number: "Customer Number",
        package_code: "รหัสแพคเกจ",
        msisdn: "หมายเลขภายในกล่อง",
        esn: "ESN",
        imei: "IMEI",
        contact_number: "หมายเลขติดต่อ",
        location: "ตำแหน่งลงทะเบียน (Lat,Lng)",
        distance: "ระยะล๊อค (ม.)",
        created_date: "วันที่ลงทะเบียน",
        register_date: "วันที่เปิดเบอร์",
        pcrf_status: "สถานะบน PCRF",
        customer_status: " สถานะของลูกค้า",
        sms_lang: "ภาษาของ SMS",
        telp_type: "ประเภท",
        site_prefix: "จังหวัด",
        pcrf: {
          count: "จำนวนที่ออกนอกพื้นที่",
          last_active: "สถานะล่าสุด"
        },
        back: "กลับ",
        unregister: "ยกเลิกการลงทะเบียน"
      },
      tabs: {
        title: {
          home_location: "ตำแหน่งของลูกค้า",
          retry_queue: "Retry Queue",
          customer_history: "ประวัติการแก้ไขข้อมูล",
          pcrf_history: "ประวัติสถานะ PCRF"
        },
        table: {
          created: "วันที่",
          action: "สถานะ",
          retry_queue: {
            not_found: "ไม่พบข้อมูล Retry Queue",
            transaction_id: "หมายเลขอ้างอิง",
            next_retry: "Retry ครั้งต่อไป",
            retry_count: "จำนวนการ Retry",
            type: "ประเภท"
          },
          cust_history: {
            not_found: "ไม่พบประวัติการแก้ไขข้อมูลลูกค้า",
            event: "ประเภทข้อมูล",
            old: "ข้อมูลเก่า",
            new: "ข้อมูลใหม่",
            create_by: "แก้ไขโดย"
          },
          pcrf_history: {
            not_found: "ไม่พบประวัติการออกนอกพื้นที่บน PCRF"
          }
        }
      },
      unregister_popup: {
        title: "ยกเลิกการลงทะเบียน",
        description: "กรุณายืนยันที่จะยกเลิกการลงทะเบียนของหมายเลข ",
        confirm: "ยืนยัน",
        cancel: "ไม่ใช่ตอนนี้"
      }
    },
    prospects: {
      title: "รายชื่อลูกค้าที่ให้ความสนใจ Dtac@home",
      table_header: {
        created: "วันที่กรอก",
        name: "ชื่อลูกค้า",
        global_id: "Global ID",
        msisdn: "หมายเลขโทรศัพท์",
        email: "อีเมล์",
        address: "ที่อยู่",
        province: "จังหวัด",
        coordinate: "ตำแหน่ง (Lat, Lng)",
        area_status: "สถานะ",
        action: "จัดการ",
        tooltip: "ดีลพนักงาน"
      },
      detail_title: {
        change_event: "สถานะที่เปลี่ยน",
        last_updated: "อัพเดทล่าสุดเมื่อ",
        updated_date: "วันที่แก้ไข",
        by: "โดย"
      },
      call_status_title: {
        new: "ยังไม่มีการโทร",
        called: "รอผลการโทร",
        accepted: "ตกลงซื้อแล้ว"
      },
      area_status_title: {
        in_area: "อยู่ในพื้นที่ให้บริการ",
        out_area: "อยู่นอกพื้นที่ให้บริการ"
      },
      dialog: {
        remove: {
          title: "ลบข้อมูลลูค้าที่ให้ความสนใจ",
          message: "คุณต้องการจะทำการลบลูกค้าลูกค้าที่ให้ความสนใจ",
          confirmText: "ลบ"
        },
        call: {
          title: "สถานะการติดต่อลูกค้าที่ให้ความสนใจ",
          message: "กรุณายืนยันการตอบรับจากลูกค้าที่ให้ความสนใจ",
          accepted: "ตกลงซื้อ",
          rejected: "ปฏิเสธ"
        },
        register: {
          title: "ลงทะเบียนลูกค้าที่ให้ความสนใจ",
          message: "คุณต้องการจะทำการลงทะเบียนลูกค้าหมายเลข ",
          confirmText: "ลงทะเบียน"
        },
        cancelText: "ยกเลิก"
      }
    },
    myprofile: {
      email: "อีเมล์",
      status: {
        active: "Active",
        pending: "Pending"
      },
      permission: {
        title: "การเข้าถึง",
        map_area: "วางแผนการขาย",
        customer_register: "ลงทะเบียนลูกค้า",
        customer_list: "รายชื่อลูกค้า",
        customer_update: "แก้ไขข้อมูลลูกค้า",
        report: "รายงาน",
        user_manage: "แก้ไขข้อมูลผู้ใช้ระบบ"
      },
      created: {
        title: "สร้างเมื่อ",
        by: "โดย"
      }
    },
    devices: {
      title: "จัดการอุปกรณ์",
      search: {
        placeholder: "กรุณากรอกหมายเลขโทรศัพท์, เลขimei หรือ หมายเลขเครื่อง",
        button: "กรอง"
      },
      btn_create_device: "เพิ่มอุปกรณ์ใหม่",
      table_header: {
        created: "วันที่เพิ่มเข้ามาในระบบ",
        msisdn: "หมายเลขโทรศัพท์",
        imei: "IMEI",
        esn: "ESN"
      },
      form: {
        title: "เพิ่มอุปกรณ์ใหม่",
        info:
          "กรุณากรอกข้อมูลในรูปแบบ CSV ( msisdn, IMEI, ESN, telp_type ตามลำดับ )",
        placeholder:
          "msisdn-001,IMEI-001,ESN-001,T\nmsisdn-002,IMEI-002,ESN-002,T\nmsisdn-003,IMEI-003,ESN-003,P"
      }
    },
    site: {
      coverage: "ระยะครอบคุลม (ม.)",
      distance: "ระยะห่างจากลูกค้า (ม.)",
      utilize: "การใช้งานของเสา (%)",
      cell: {
        location: "ตำแหน่งของ Cell (Lat, Lng)"
      }
    },
    form: {
      imei: {
        title: "อัพเดทข้อมูล IMEI",
        current_imei: "IMEI ปัจจุบัน",
        description: "กรุณากรอก IMEI ใหม่ ในช่องด้านล่าง",
        placeholder: "ระบุ IMEI ใหม่"
      },
      distance: {
        title: "อัพเดทรัศมีการล๊อค",
        current_distance: "รัศมีการล๊อคปัจจุบัน",
        unit: "ม.",
        description: "กรุณากรอกค่ารัศมีการล๊อคใหม่ในช่องด้านล่าง",
        placeholder: "ระบุค่ารัศมีการล๊อคใหม่"
      },
      contact: {
        title: "อัพเดทหมายเลขติดต่อ",
        current_contact: "หมายเลขติดต่อปัจจุบัน",
        description:
          "กรุณากรอกหมายเลขติดต่อใหม่ในช่องด้านล่างและ ยืนยันด้วยหมายเลขOTP เพื่อนทำการเปลี่ยนหมายเลขติดต่อ",
        placeholder: "ระบุหมายเลขติดต่อใหม่"
      },
      location: {
        title: "อัพเดทตำแหน่งลงทะเบียน"
      }
    },
    maps: {
      service_available: "อยู่ในพื้นที่ให้บริการ",
      service_unavailable: "ไม่อยู่ในพื้นที่ให้บริการ",
      site_available: "มีเสาสัญญาณให้บริการ",
      site_unavailable: "ไม่มีเสาสัญญาณให้บริการ"
    },
    error: {
      wrong_format_input:
        "Wrong Input Format, Please input Address or (Latitude, Longitude)."
    },
    alert: {
      token_not_found: "ไม่พบข้อมูล Contact Token",
      new_contact: "กรุณากรอกหมายเลขติดต่อของท่านใหม่อีกครั้ง",
      update_contact: "ทำการอัพเดทข้อมูลหมายเลขติดต่อใหม่เรียบร้อย",
      user_lan: "กรุณากรอก USE LAN ของท่าน",
      new_user_lan: "ทำการเพิ่มผู้ดูแลระบบคนใหม่เรียบร้อย",
      wrong_format_input:
        "กรุณากรอกข้อมูลในรุปแบบของที่อยุ่ หรือ Latitude, Longitude",
      valid_contact: "หมายเลขติดต่อถูกต้อง"
    }
  }
};

const i18n = new VueI18n({
  locale: "th", // set locale
  fallbackLocale: "en", // set fallback locale
  messages // set locale messages
});

export default i18n;
